import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { api, setSession, getToken } from '../api';
import { Field, Input } from '../ui';
import { LogoMark } from '../Logo';

export default function Login() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  // Sessiya bor bo'lsa — render paytida to'g'ridan-to'g'ri yo'naltiramiz (nav() emas)
  if (getToken()) return <Navigate to="/" replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      const res = await api.post('/auth/login', { login, password });
      setSession(res.accessToken, res.user, res.refreshToken);
      nav('/');
    } catch (e: any) {
      setErr(e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="login-wrap">
      <form className="card login-card" onSubmit={submit}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}><LogoMark size={62} /></div>
          <div className="brand-name" style={{ fontSize: 22 }}>ALIGHT</div>
          <div className="brand-sub" style={{ marginTop: 4 }}>Import Manager</div>
        </div>
        <Field label="Login">
          <Input value={login} onChange={(e) => setLogin(e.target.value)} autoFocus autoComplete="username" />
        </Field>
        <Field label="Parol">
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        </Field>
        {err && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 12 }}>{err}</div>}
        <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '11px' }} disabled={loading}>
          {loading ? 'Kirilmoqda…' : 'Kirish'}
        </button>
      </form>
    </div>
  );
}
